export const NEGATION_PARAM = "not"

/**
 * Negated filters travel as one `not=` param holding the param names of the
 * filters the user flipped to "is not".
 */
export function serializeNegations<T extends string>(
	negations: Partial<Record<string, boolean>>,
	paramKeys: Record<T, string>,
): string {
	return (Object.keys(paramKeys) as T[])
		.filter((key) => negations[key])
		.map((key) => paramKeys[key])
		.join(",")
}

export function deserializeNegations<T extends string>(
	param: string,
	paramKeys: Record<T, string>,
): Partial<Record<T, boolean>> {
	if (!param) return {}
	const names = new Set(param.split(","))
	const negations: Partial<Record<T, boolean>> = {}
	for (const key of Object.keys(paramKeys) as T[]) {
		if (names.has(paramKeys[key])) negations[key] = true
	}
	return negations
}
